import { Sprite } from 'pixi.js';
import type { Container } from 'pixi.js';
import { onLayoutPopulated } from '../populate';
import MathUtils from '../../../utils/MathUtils';

export function layoutShineSPL(): void {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  onLayoutPopulated.connect((layout: { root: Container; shine_SPL?: Container[] }) => {
    if (!layout.shine_SPL) return;

    layout.shine_SPL.forEach(async (object) => {
      const shine = new Sprite().props({
        parent: object,
        texture: 'Shine',
        blendMode: 'add',
        anchor: 0.5,
        alpha: 0,
        scaleXY: 0,
      });

      // eslint-disable-next-line no-constant-condition
      while (!shine.destroyed) {
        await shine.wait(MathUtils.rnd.between(400, 2000));

        const duration = MathUtils.rnd.between(600, 1200);

        shine.tweenTo(
          {
            angle: MathUtils.rnd.between(90, 270),
            scaleXY: MathUtils.rnd.realInRange(0.5, 1),
          },
          duration,
          'linear',
          true,
        );

        await shine
          .tweenTo(
            {
              alpha: 0.8,
            },
            duration * 0.5,
            'sinIn',
            true,
            0,
            0,
            true,
          )
          .asyncOnComplete();

        shine.props({
          alpha: 0,
          angle: 0,
          scaleXY: 0,
        });
      }
    });
  });
}
